import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ErrorSec = ({ className = "space overflow-hidden" }) => {
  const { t } = useTranslation();

  return (
    <section className={className}>
      <div 
        className="shape-mockup bg-gradient-shape1 contact-bg-gradient1" 
        data-top="15%" 
        data-left="3%"
      ></div>
      <div 
        className="shape-mockup bg-gradient-shape1 contact-bg-gradient1" 
        data-top="auto" 
        data-bottom="15%" 
        data-left="auto" 
        data-right="3%"
      ></div>
      <div className="container">
        <div className="error-img" data-cue="slideInUp">
          <img src="assets/img/theme-img/error.png" alt={t('sections.errorSec.img_alt','Error 404')} />
        </div>
        <div className="error-content">
          <h1 className="error-title" data-cue="slideInUp" data-delay="100">
            {t('sections.errorSec.title','PAGE NOT FOUND')}
          </h1>
          <p className="error-text" data-cue="slideInUp" data-delay="200">
            {t('sections.errorSec.text',"Oops, it seems like this page doesn't exist. You might want to try searching or explore one of the links below.")}
          </p>
          <Link to="/" className="ot-btn" data-cue="slideInUp" data-delay="300">
            {t('sections.errorSec.back','Back To Home')} <i className="fal fa-home ms-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ErrorSec;